import React from "react";
import { useLocation } from "react-router-dom";

import MainTemplate from "../../../components/MainTemplate/MainTemplate";
import CardBackground from "../../../components/MainTemplate/CardBackground";
import IncomeDuesUpdateChild from "./IncomeDuesUpdateChild";

const IncomeDuesUpdate = () => {
  const location = useLocation();
  const selectedRecord = location.state;

  return (
    <MainTemplate>
      <CardBackground>
        <IncomeDuesUpdateChild selectedRecord={selectedRecord} />
      </CardBackground>
    </MainTemplate>
  );
};

export default IncomeDuesUpdate;
